import { assertEvent, assign } from 'xstate';

import { type ScrollspyVirtualizedAction } from '../scrollspy-virtualized.types';

// ─────────────────────────────────────────────────────────────────────────────

const activateRequestedTarget: ScrollspyVirtualizedAction = assign(({ event }) => {
  assertEvent(event, 'SCROLL_TO_TARGET');

  return { activeTargetId: event.targetId, pendingTargetId: event.targetId };
});

const activateVisibleTarget: ScrollspyVirtualizedAction = assign({
  activeTargetId({ context, event }) {
    assertEvent(event, 'SET_VISIBLE_TARGETS');

    return event.targetIds[0] ?? context.activeTargetId;
  },
});

const clearPendingTarget: ScrollspyVirtualizedAction = assign({ pendingTargetId: undefined });

const recomputeVisibleTargets: ScrollspyVirtualizedAction = ({ context }) => {
  context.listRef.current?.recomputeViewableItems();
};

// External action
const onActiveTargetChange: ScrollspyVirtualizedAction = () => {};

// ─────────────────────────────────────────────────────────────────────────────

export const Actions = {
  activateRequestedTarget,
  activateVisibleTarget,
  clearPendingTarget,
  recomputeVisibleTargets,
  onActiveTargetChange,
};
